var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"64"}}),_c('h3',[_vm._v("Procesando pago...")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }